
define('text!templates/unload_alert_bulkedit.html',[],function () { return '<div class="unload-alert" style="display: none;">\n\t<div class="w-body">\n\t\t<div class="icon"><b></b></div>\n\t\t<div class="message">\n\t\t\t<div class="head">Unstaged Changes!</div>\n\t\t\t<div class="message-c">Your changes will be lost if you don\'t stage them.</div>\n\t\t</div>\n\t</div>\n</div>';});

